import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface RightPanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  width?: 'md' | 'lg' | 'xl';
}
export function RightPanel({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  width = 'lg'
}: RightPanelProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  const widthClasses = {
    md: 'w-[480px]',
    lg: 'w-[640px]',
    xl: 'w-[800px]'
  };
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} data-id="element-614" />

      {/* Panel */}
      <div className={`fixed right-0 top-0 h-full ${widthClasses[width]} bg-white dark:bg-dark-surface border-l border-gray-200 dark:border-dark-subtle shadow-2xl z-50 transform transition-transform duration-300 ease-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-615">
        <div className="flex flex-col h-full" data-id="element-616">
          {/* Header */}
          <div className="flex-shrink-0 px-6 py-5 border-b border-gray-100 dark:border-dark-subtle" data-id="element-617">
            <div className="flex items-start justify-between" data-id="element-618">
              <div className="flex-1 min-w-0 mr-4" data-id="element-619">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 truncate" data-id="element-620">
                  {title}
                </h2>
                {subtitle && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-621">
                    {subtitle}
                  </p>}
              </div>
              <button onClick={onClose} className="flex-shrink-0 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-hover rounded-lg transition-all duration-180" data-id="element-622">
                <X className="w-5 h-5" data-id="element-623" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto custom-scrollbar" data-id="element-624">
            {children}
          </div>
        </div>
      </div>
    </>;
}